export default (callback, name) => {
    app.modules.use('app.contacts.add').then(() => {
        app.contacts.add({ name }, callback);
    });
};
